import React from "react";
import { Form, ProgressBar } from "react-bootstrap";

export const QuizForm = () => {
  return (
    <div className="quiz-form">
      {/* <Form.Group className="d-flex flex-row mt-5">
        <Form.Label className="fw-bold me-3 mb-0 mt-1">Thời gian làm bài</Form.Label>
        <Form.Control className="w-auto" type="number" placeholder="0 phút" />
      </Form.Group> */}
    </div>
  );
};
